/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import { getSetting } from "@dvrd/dvr-controls";

let isLoggedIn: boolean = false;

export const setMaintenanceLoggedIn = (loggedIn: boolean) => {
    isLoggedIn = loggedIn;
};

export const getMaintenanceLoggedIn = () => isLoggedIn;

export const requireMaintenanceLogin = (): boolean => getSetting('maintenanceMode') && !isLoggedIn;